// SELL ticket sizing as the trade will be created (3 Nov 2026). With Profit-Lock chosen the backend plans ONE original
// CE/PE pair (models.initial_pairs) and keeps the rest of the usable allocation for the Profit-Lock adjustments; the
// preview's own planned_pairs is what the allocation could fund (still sent as `expected`, the backend compares it).
export function ticketSizing(preview, { plock = false } = {}) {
  if (!preview) return null;
  const lines = preview.lines || {};
  const allocated = lines.allocated_fund ?? null;
  const reserve = lines.reserve ?? null;
  const usable = allocated != null && reserve != null ? Math.round((allocated - reserve) * 100) / 100 : null;
  const affordable = preview.planned_pairs ?? null;
  const planned = affordable == null ? null : plock ? Math.min(affordable, 1) : affordable;
  const cpp = preview.capital_per_pair ?? null;
  const headroom = plock && planned && usable != null && cpp != null ? Math.round((usable - cpp * planned) * 100) / 100 : null;
  return { allocated, reserve, reservePct: lines.reserve_pct ?? null, usable, affordable, planned, capitalPerPair: cpp,
    marginPerPair: lines.margin_per_pair?.margin ?? null, onePair: !!plock && affordable != null && affordable > planned, headroom };
}
